module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con01"
    }
  }, [_c('h2', {
    staticClass: "contentsHead",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780312340391_ack#ack"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780312340391_fm02#fm02"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780312340391_ch01#ch01"
    }
  }, [_vm._v("1 The Park Avenue Mind-Set")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780312340391_ch02#ch02"
    }
  }, [_vm._v("2 Protein—The Anchor of Your Diet")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312340391_ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Calcium—The Miracle Mineral")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312340391_ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Dr. Klauer’s Diet Plan")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312340391_ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Curb Your Cravings: The Stop! Watch! Method")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312340391_ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 The Stop! Watch! Method of Exercise")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312340391_ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Anti-Aging Nutrition: Live Longer and Look Younger")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312340391_ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Your Outside Is a Mirror of Your Inside")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312340391_ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Dr. Klauer’s Recipes")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312340391_bm01#bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312340391_bm02#bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312340391_bm03#bm03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312340391_bm04#bm04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-090b9a39","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312340391_con01.vue
// module id = 72
// module chunks = 0